import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-koine',
  templateUrl: './home-koine.component.html',
  styleUrls: ['./home-koine.component.css']
})
export class HomeKoineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
